import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import './index.css'
import 'github-markdown-css/github-markdown.css'
import './components/Documents/markdown-dark.css'

// 개발 환경에서만 전역 테스트 함수 추가
if (import.meta.env.DEV) {
  // 현재 storageStore 상태 확인 함수
  (window as any).checkStorageStoreState = async () => {
    try {
      const { useStorageStore } = await import('./stores/storageStore');
      const store = useStorageStore.getState();
      

      
      return store;
      
    } catch (error) {
      console.error('❌ StorageStore 상태 확인 실패:', error);
      return null;
    }
  };

  // 강제 세션 로드 함수
  (window as any).forceLoadSessions = async () => {
    try {
      const { useStorageStore } = await import('./stores/storageStore');
      const store = useStorageStore.getState();
      
      console.log('🔄 강제 세션 로드 시작...');
      await store.loadSessions();
      
      const updatedStore = useStorageStore.getState();
      console.log('✅ 세션 로드 완료:', {
        sessionsCount: updatedStore.sessions.length,
        sessions: updatedStore.sessions
      });
      
      return updatedStore.sessions;
      
    } catch (error) {
      console.error('❌ 강제 세션 로드 실패:', error);
      return [];
    }
  };

  console.log('🔧 디버깅 함수들이 window 객체에 등록되었습니다:');
  console.log('- window.checkStorageStoreState()');
  console.log('- window.forceLoadSessions()');
}

// Cache busting - 브라우저 캐시 강제 새로고침
const forceCacheRefresh = () => {
  // 빌드 타임스탬프 확인
  const buildTimestamp = document.querySelector('meta[name="build-timestamp"]')?.getAttribute('content');
  const storedTimestamp = localStorage.getItem('app-build-timestamp');
  
  if (buildTimestamp && buildTimestamp !== 'BUILD_TIMESTAMP_PLACEHOLDER') {
    if (storedTimestamp && storedTimestamp !== buildTimestamp) {
      console.log('🔄 New build detected, clearing cache...');
      // 캐시 클리어
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }
      // 로컬 스토리지 일부 클리어 (설정은 유지)
      const keysToPreserve = ['linkband-settings', 'linkband-storage-config'];
      const allKeys = Object.keys(localStorage);
      allKeys.forEach(key => {
        if (!keysToPreserve.some(preserve => key.includes(preserve))) {
          localStorage.removeItem(key);
        }
      });
    }
    // 새로운 빌드 타임스탬프 저장
    localStorage.setItem('app-build-timestamp', buildTimestamp);
  }
};

// 캐시 새로고침 실행
forceCacheRefresh();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
)
